<app-menu [hasChanges]="loadMenu" title="Abono a cartera"></app-menu>
<app-loading [show]="load"></app-loading>
<div class="p-2">
    <div class="flex flex-column md:flex-row justify-content-between">
        <div>Cliente<span class="uppercase">{{(formClient.controls.nombres.value ??'') !='' ? ': ' +
                formClient.controls.nombres.value : ''}}</span></div>
        <div class="flex flex-column md:flex-row">
            <button pButton label="Ver información" class="p-button p-button-outlined p-button-success" icon="pi pi-eye"
                (click)="displayInfoClient=true"></button>
            <button pButton label="Consultar nuevo cliente" class="p-button p-button-outlined p-button-danger"
                icon="pi pi-times-circle" (click)="reload()"></button>
        </div>
    </div>

    <p-accordion [activeIndex]="2">
        <p-accordionTab header="Información de cupo" [(selected)]="activeState[3]" id="div2">
            <div class="p-fluid p-2">
                <form [formGroup]="formAsignacion">
                    <div class="grid">
                        <div class="col-12 md:col-6">
                            <label>Valor asignado</label>
                            <p-inputNumber class="w-full" placeholder="Valor asignado" formControlName="valorAsignado">
                            </p-inputNumber>
                        </div>
                        <div class="col-12 md:col-6">
                            <label>Valor consumido</label>
                            <p-inputNumber class="w-full" placeholder="Valor consumido"
                                formControlName="valorConsumido">
                            </p-inputNumber>
                        </div>
                        <div class="col-12 text-center">
                            <label>Valor disponible {{((formAsignacion.controls.valorAsignado.value??0) -
                                (formAsignacion.controls.valorConsumido.value??0)) | currency}}</label>
                        </div>
                    </div>
                </form>
            </div>
        </p-accordionTab>
        <p-accordionTab header="Detalle cartera" [(selected)]="activeState[2]"
            *ngIf="(formAsignacion.controls.valorConsumido.value ??0) > 0">
            <div class="grid">
                <div class="col-6 md:col-3 text-center">Fecha</div>
                <div class="col-6 md:col-3 text-center">Nro. venta</div>
                <div class="col-12 md:col-6 text-center">Valor crédito</div>
            </div>
            <div class="grid" *ngFor="let item of detalleCartera">
                <div class="col-6 md:col-3 text-center">{{item.fecha | date:'medium'}}</div>
                <div class="col-6 md:col-3 text-center"><button pButton class="p-button p-button-link"
                        (click)="searchNumber(item.idVenta)" label="{{item.idVenta}}"></button></div>
                <div class="col-12 md:col-6 text-center">{{item.valor| currency}}</div>
            </div>
        </p-accordionTab>
        <p-accordionTab header="Generar abonos" [(selected)]="activeState[3]"
            *ngIf="(formAsignacion.controls.valorConsumido.value??0) > 0">
            <div class="flex flex-wrap">
                <div class="w-full md:w-4 pt-3">
                    <label>Ingrese el valor a abonar</label>
                    <div class="p-inputgroup">
                        <span class="p-inputgroup-addon"><i class="pi pi-dollar"></i></span>
                        <p-inputNumber mode="currency" currency="USD" [minFractionDigits]="0" locale="en-US"
                            [(ngModel)]="valorAbonoCartera" [max]="formAsignacion.controls.valorConsumido.value??0">
                        </p-inputNumber>
                    </div>
                </div>
                <div class="w-full md:w-4 flex flex-row md:justify-content-center pt-3">
                    <div>
                        <label>Forma de Pago</label>
                        <p-autoComplete [dropdown]="true" [(ngModel)]="selectedMethod" [suggestions]="metodoPagoFilter"
                            (completeMethod)="filterMetodo($event)" field="label" [multiple]="false">
                        </p-autoComplete>
                        <div class="p-2" *ngIf="selectedMethod.idVentaMetodoPago > 1">
                            <div class="grid borderBottom">
                                <div class="col-12">
                                    <label>Digite referencia {{selectedMethod.label}}</label>
                                    <input class="w-full" type="text" placeholder="Referencia de pago" pInputText
                                        [(ngModel)]="selectedMethod.referencia" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="w-full md:w-4 text-center pt-3">
                    <button pButton #btn class="p-button p-button-success" label="Realizar abono" (click)="setAbono()"
                        icon="pi pi-check-circle"></button>
                </div>
            </div>
        </p-accordionTab>
        <p-accordionTab header="Detalle abonos realizados" [(selected)]="activeState[4]"
            *ngIf="(formAsignacion.controls.valorConsumido.value??0) > 0">
            <div class="grid">
                <div class="col-6 md:col-3 text-center">Fecha</div>
                <div class="col-6 md:col-3 text-center">Forma de pago</div>
                <div class="col-12 md:col-6 text-center">Valor</div>
            </div>
            <div class="grid" *ngFor="let item of abonoCarteras">
                <div class="col-4 md:col-3 text-center">{{item.fecha | date:'medium'}}</div>
                <div class="col-4 md:col-3 text-center"> {{item.metodoPago}}</div>
                <div class="col-12 md:col-6 text-center">{{item.valor| currency}}</div>
            </div>
        </p-accordionTab>
    </p-accordion>
</div>
<p-dialog [(visible)]="showTicket" [modal]="true">
    <div>
        <iframe #queryFrame src="" title="Consulta de tickets" width="100%" height="600" style="border: none;">
        </iframe>
    </div>
</p-dialog>

<p-dialog header="INFORMACIÓN DEL CLIENTE" [(visible)]="displayInfoClient" [modal]="true" [closable]="false"
    [position]="'top'" [breakpoints]="{'960px': '75vw', '640px': '100vw'}">
    <p>Los campos seguidos de un * (asterisco) son obligatorios</p>
    <div class="p-inputgroup w-full mb-5">
        <div class="p-element p-inputgroup-addon"><label><i class="pi pi-search"></i></label></div>
        <div class="w-full">
            <p-autoComplete id="busqueda" [tabindex]="1" [suggestions]="resultsLsClients"
                (completeMethod)="searchItemClient($event)" field="razonSocial" [minLength]="1"
                (onSelect)="searchItemViewClient($event)" [style]="{'width':'100%'}" [inputStyle]="{'width':'100%'}"
                [(ngModel)]="fieldSearchClient" (onKeyUp)="clearFormCliente(true)" [showClear]="true"
                placeholder="Busqueda de cliente por nombre o identificación"></p-autoComplete>
        </div>
    </div>

    <form [formGroup]="formClient">
        <div class="grid">
            <div class="w-full md:w-6 flex flex-wrap">
                <div class="w-full md:w-3 p-1">
                    <label class="pb-2">Tipo de identificación <span class="text-lg text-red-700">*</span></label>
                    <p-select [options]="listIdentificationType" optionLabel="descripcion" (onChange)="searchClient()"
                        placeholder="Tipo de identificación" formControlName="tipo"
                        class="{{this.formClient.controls.tipo.valid && lockedFieldsIdClient ? 'disabledFillFields':''}}"></p-select>
                </div>
                <div class="w-full md:w-9 p-1">
                    <label class="pb-2">Nro. de identificación <span class="text-lg text-red-700">*</span> <span
                            class="text-xs" *ngIf="formClient.value.tipo?.idTipoIdentificacion ==3">
                            Ingrese la información sin puntos y sin dígito de verificación</span></label>
                    <div class="p-inputgroup"><input pInputText type="text" class="w-full"
                            placeholder="Nro. de Identificación" formControlName="identificacion" autocomplete="off"
                            (keyup)="clearFormCliente()" (blur)="searchClient()"
                            class="{{lockedFieldsIdClient?'disabledFillFields':''}}">
                        <div class="p-inputgroup-addon">
                            <label>{{digito??''}}</label>
                        </div>
                    </div>

                </div>
            </div>

            <div class="w-full md:w-6 p-1" *ngIf="formClient.value.tipo?.idTipoIdentificacion ==3">
                <label class="pb-2">Razón Social <span class="text-lg text-red-700">*</span></label>
                <input pInputText type="text" class="w-full uppercase" placeholder="Razon Social"
                    formControlName="razonSocial" autocomplete="off">
            </div>

            <div class="w-full md:w-6 p-1">
                <label class="pb-2">Contacto <span class="text-lg text-red-700">*</span></label>
                <input pInputText type="text" class="w-full uppercase" placeholder="Nombres y Apellidos"
                    formControlName="nombres" autocomplete="off">
            </div>
            <div class="w-full md:w-6 p-1">
                <label class="pb-2">Correo electrónico <span class="text-xs text-red-700">*</span></label>
                <input pInputText type="text" class="w-full lowercase" placeholder="Correo Electrónico"
                    formControlName="correo">
            </div>
            <div class="w-full md:w-6 p-1">
                <label class="pb-2">Nro. de teléfono</label>
                <input pInputText type="text" class="w-full" placeholder="Nro. de celular" formControlName="telefono">
            </div>
            <!--************************* Section Additional information **************************************-->
            <div class="w-full">
                <p-accordion>
                    <p-accordionTab header="Información adicional del cliente (opcional)">
                        <div class="w-full flex flex-wrap">
                            <div class="w-full md:w-6 p-1">
                                <label class="pb-2">Dirección</label>
                                <input pInputText type="text" class="w-full" placeholder="Dirección"
                                    formControlName="direccion">
                            </div>
                            <div class="w-full md:w-6 p-1">
                                <label class="pb-2">Departamento</label>
                                <p-select [options]="listDptos" [filter]="true" optionLabel="nombreDepartamento"
                                    placeholder="Departamento" formControlName="departamento"
                                    (onChange)="loadCities()"></p-select>
                            </div>
                            <div class="w-full md:w-6 p-1">
                                <label class="pb-2">Ciudad</label>
                                <p-select [options]="listCities" [filter]="true" optionLabel="nombreCiudad"
                                    placeholder="Ciudad" formControlName="ciudad"></p-select>
                            </div>
                        </div>
                    </p-accordionTab>
                </p-accordion>

            </div>

            <!--End Section-->
            <div class="mx-auto w-full text-right">
                <button pButton class="p-button p-button-danger" icon="pi pi-times-circle" label="No elegir cliente"
                    (click)="volver()"></button>&nbsp;
                <button pButton class="p-button p-button-success" icon="pi pi-check" label="Continuar"
                    (click)="searchClient()"></button>
            </div>
        </div>
    </form>
</p-dialog>

<p-toast></p-toast>